module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 82);
/******/ })
/************************************************************************/
/******/ ({

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  inject: {
    rootMenu: {
      default: function _default() {
        return { name: 'rootMenu' };
      }
    }
  },
  computed: {
    indexPath: function indexPath() {
      var path = [this.index];
      var parent = this.$parent;
      while (parent.$options.componentName !== 'KdMenu') {
        if (parent.index) {
          path.unshift(parent.index);
        }
        parent = parent.$parent;
      }
      return path;
    },
    parentMenu: function parentMenu() {
      var parent = this.$parent;
      while (parent && ['KdMenu', 'KdSubmenu'].indexOf(parent.$options.componentName) === -1) {
        parent = parent.$parent; // 排除 menu-item-group
      }
      return parent;
    },
    parentMenuName: function parentMenuName() {
      return this.parentMenu && this.parentMenu.$options.componentName;
    }
  }
});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@kdocs/kdesign-icons-vue");

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=43af3dd5&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: {
        "kdv-menu-item": true,
        "is-active": _vm.active,
        "is-disabled": _vm.disabled,
        "kdv-menu-item--divided": _vm.divided,
      },
      attrs: { role: "menuitem", tabindex: "-1" },
      on: { click: _vm.handleClick },
    },
    [
      _c("div", { staticClass: "kdv-menu-item__block" }, [
        _vm.showSelect
          ? _c(
              "div",
              { staticClass: "kdv-menu-item__selected-area" },
              [
                _c("kd-icon-tick", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selected,
                      expression: "selected",
                    },
                  ],
                  attrs: { fill: "#0A6CFF", size: "16", strokeWidth: "2" },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.$slots.prefix || _vm.prefixIcon
          ? _c(
              "div",
              { staticClass: "kdv-menu-item__prefix" },
              [
                _vm.$slots.prefix
                  ? _vm._t("prefix")
                  : _c("kd-icon", {
                      attrs: {
                        icon: _vm.prefixIcon,
                        size: _vm.prefixIconSize,
                        color: _vm.prefixIconColor,
                      },
                    }),
              ],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "kdv-menu-item__wrap" }, [
          _c("div", { staticClass: "kdv-menu-item__top" }, [
            _c(
              "div",
              { staticClass: "kdv-menu-item__content" },
              [
                _vm.$slots.default
                  ? _vm._t("default")
                  : _vm.title
                  ? _c("span", [_vm._v(_vm._s(_vm.title))])
                  : _vm._e(),
                _vm.$slots.assist
                  ? _c(
                      "span",
                      { staticClass: "kdv-menu-item__title-suffix" },
                      [_vm._t("assist")],
                      2
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm.$slots.suffix || _vm.suffixText
              ? _c(
                  "div",
                  { staticClass: "kdv-menu-item__suffix" },
                  [
                    _vm.$slots.suffix
                      ? _vm._t("suffix")
                      : [_vm._v(_vm._s(_vm.suffixText))],
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "kdv-menu-item__arrow-icon" },
              [
                _c("kd-icon-arrow-right", {
                  attrs: { fill: "#757575", size: "16", strokeWidth: "2" },
                }),
              ],
              1
            ),
          ]),
          _vm.$slots.subtitle || _vm.subtitle
            ? _c(
                "div",
                { staticClass: "kdv-menu-item__bottom" },
                [
                  _vm.$slots.subtitle
                    ? _vm._t("subtitle")
                    : [_vm._v(_vm._s(_vm.subtitle))],
                ],
                2
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=43af3dd5&

// EXTERNAL MODULE: ./packages/menu/src/menu-mixin.js
var menu_mixin = __webpack_require__(49);

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(7);

// EXTERNAL MODULE: ./packages/icon/index.js + 5 modules
var icon = __webpack_require__(9);

// EXTERNAL MODULE: external "@kdocs/kdesign-icons-vue"
var kdesign_icons_vue_ = __webpack_require__(6);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var menu_itemvue_type_script_lang_js_ = ({
  name: 'KdMenuItem',

  componentName: 'KdMenuItem',

  mixins: [menu_mixin["a" /* default */], emitter["a" /* default */]],

  components: {
    KdIcon: icon["default"],
    KdIconArrowRight: kdesign_icons_vue_["ArrowRight"],
    KdIconTick: kdesign_icons_vue_["Tick"]
  },

  props: {
    index: {
      default: null,
      validator: function validator(val) {
        return typeof val === 'string' || val === null;
      }
    },
    route: [String, Object],
    divided: Boolean, // 分隔线
    disabled: Boolean,
    selectable: Boolean, // 开启可选
    selected: Boolean, // 选中状态

    // 菜单项元素
    title: String, // 标题
    subtitle: String, // 次级标题
    suffixText: String, // 尾部文本
    prefixIcon: Object, // 头部图标
    prefixIconSize: {
      type: Number,
      default: 16
    },
    prefixIconColor: String
  },
  watch: {
    disabled: function disabled(val) {
      this.dispatch('KdSubmenu', 'item-disabled-change');
    }
  },
  computed: {
    rootMenuComp: function rootMenuComp() {
      return this.rootMenu || {}; // 未必有外层 menu 组件
    },
    isReference: function isReference() {
      return this.$vnode.data.slot === 'reference';
    },
    active: function active() {
      return this.index === this.rootMenuComp.activeIndex;
    },
    showSelect: function showSelect() {
      var showSelect = void 0;
      if (this.isReference && this.parentMenuName === 'KdSubmenu') {
        showSelect = this.parentMenu.parentMenu.selectable;
      }
      if (!this.isReference) {
        showSelect = this.parentMenu.selectable;
      }
      return showSelect || this.selectable;
    }
  },
  methods: {
    handleClick: function handleClick() {
      if (!this.disabled && !this.isReference) {
        this.dispatch('KdMenu', 'item-click', this);
        this.$emit('click', this);
        this.showSelect && this.$emit('update:selected', !this.selected);
      }
    }
  },
  mounted: function mounted() {
    this.parentMenu && !this.isReference && this.parentMenu.addItem(this);
    this.rootMenu && !this.isReference && this.rootMenu.addItem(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.parentMenu && this.parentMenu.removeItem(this);
    this.rootMenu && this.rootMenu.removeItem(this);
  }
});
// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_menu_itemvue_type_script_lang_js_ = (menu_itemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_menu_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var menu_item = (component.exports);
// CONCATENATED MODULE: ./packages/menu-item/index.js


/* istanbul ignore next */
menu_item.install = function (Vue) {
  Vue.component(menu_item.name, menu_item);
};

/* harmony default export */ var packages_menu_item = __webpack_exports__["default"] = (menu_item);

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=36df1560&
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSvgIcon
    ? _c(_vm.icon, {
        tag: "component",
        class: _vm.iconClass,
        attrs: { size: _vm.size, fill: _vm.color },
      })
    : _c("i", { class: "el-icon-" + _vm.name })
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=36df1560&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var iconvue_type_script_lang_js_ = ({
  name: 'KdIcon',
  props: {
    name: String,
    icon: Object,
    size: Number | String,
    color: String,
    iconClass: String
  },
  data: function data() {
    return {
      propsClass: this.iconClass
    };
  },

  computed: {
    isSvgIcon: function isSvgIcon() {
      return _typeof(this.icon) === 'object';
    }
  }
});
// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_iconvue_type_script_lang_js_ = (iconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/icon/src/icon.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_iconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icon = (component.exports);
// CONCATENATED MODULE: ./packages/icon/index.js


/* istanbul ignore next */
icon.install = function (Vue) {
  Vue.component(icon.name, icon);
};

/* harmony default export */ var packages_icon = __webpack_exports__["default"] = (icon);

/***/ })

/******/ });